import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AngularFireAuth } from "angularfire2/auth";
import { CotizacionesService } from "../../services/cotizaciones.service";
import { ChatService } from "../../services/chat.service";
import { GoogleMapaService } from "../../services/google-map.service";
import { ClientesService } from "../../services/clientes.service";
import { UsuariosPersonalService } from "../../services/usuarios-personal.service";
import {
    imgReglas,
    imgConfirmacion,
    imgCotizacion,
    monosVerdes,
    oxxoImg,
} from "../cotizacion/imagenes-base";
import { AngularFireDatabase } from "angularfire2/database";
import { ConfirmacionesService } from "app/services/confirmaciones.service";
//variable necesaria para importar en ella todo lo relacionado a google maps
declare var google: any;
declare let jsPDF;
declare var require: any;

const ioBarcode = require("io-barcode");
@Component({
    selector: "app-cotizacion",
    templateUrl: "./cotizacion.component.html",
    styleUrls: ["./cotizacion.css"],
})
export class CotizacionComponent implements OnInit {
    constructor(
        private afDB: AngularFireDatabase,
        private activatedRoute: ActivatedRoute,
        private cotizacionesService: CotizacionesService,
        private chatService: ChatService,
        private afAuth: AngularFireAuth,
        private googleService: GoogleMapaService,
        private clientesService: ClientesService,
        private personalService: UsuariosPersonalService,
        private confirmacionesService: ConfirmacionesService
    ) {}

    fechaActual: number;
    opcion: any = "unidades";
    cotizacion: Observable<any>;
    cotizacionId: any;
    arregloServicios = [];
    arregloParadas = [];
    totalConceptos: number;
    codigoDeBarrasOxxo: any;
    codigoDeBarrasOxxoImagen: any;
    cotizacionCompleta: any;
    //Variables para el PDF
    nombreCliente: any;
    nombreAgente: any;
    //variables para el mapa
    private map: any;
    private directionsService: any;
    private directionsDisplay: any;
    urlPDF: any;

    printing: any = false;

    private currentUser: any; // Usuario actual

    seccion = "";
    mi_trosten_seccion = "tipo1";
    camionetas_seccion = "tipo1";
    consideracionesData: any = { horas_extras: [], cancelaciones: [], reprogramaciones: [] };
    servicio_obj: any;
    cotizacion_obj: any;
    puntosIntermedios_array = [];
    combinaciones_arr = [];

    showLoader: any = true;

    mensajeDescuento: any = "";

    marcarComoLeido() {}
    ngOnInit() {
        this.cargarConsideracionesAdicionales();
        // Obtiene el id de la confirmación

        let departamento = window.localStorage.getItem(
            "departamentoRolUsuario"
        );
        if (
            departamento == "Ventas" ||
            departamento == "GYO_Super_Admin" ||
            departamento == "Admin"
        ) {
            this.activatedRoute.params.forEach((params: Params) => {
                this.cotizacionId = params["id"];
                this.fechaActual = Date.now(); // Obtiene la fecha de hoy
                this.cotizacion = this.cotizacionesService
                    .obtenerCotizacion(this.cotizacionId)
                    .valueChanges()
                    .take(1);
                this.cotizacion.subscribe((cotizacion) => {
                    let servicios_arr = [];

                    console.log("cotizacion", cotizacion);
                    this.cotizacion_obj = cotizacion;
                    for (var idServicio in cotizacion.servicios) {
                        servicios_arr.push(cotizacion.servicios[idServicio]);
                    }

                    this.confirmacionesService
                        .traerInfoDescuentos()
                        .take(1)
                        .subscribe((res) => {
                            //console.log("descuentos",res)
                            const descuentos = res as any[];
                            descuentos.forEach((value) => {
                                if (
                                    value.idc_codigos_descuento ==
                                    cotizacion.descuentoAGuardarMark
                                        .idc_codigos_descuento
                                ) {
                                    cotizacion.descuentoAGuardarMark = value;
                                }
                            });
                            console.log(
                                "descuentoAGuardarMark",
                                cotizacion.descuentoAGuardarMark
                            );
                            if (cotizacion.descuentoAGuardarMark) {
                                if (cotizacion.descuentoAGuardarMark.codigo) {
                                    this.mensajeDescuento =
                                        cotizacion.descuentoAGuardarMark.mensaje;
                                }
                            }
                            if (cotizacion.descuentoAGuardarAdmin) {
                                if (cotizacion.descuentoAGuardarAdmin.codigo) {
                                    this.mensajeDescuento =
                                        cotizacion.descuentoAGuardarAdmin.mensaje;
                                }
                            }
                        });

                    let precio = 0;
                    let tipo_unidad = "";
                    let num_unidades = "";
                    let combinaciones = [];
                    let conceptosAdicionales = [];

                    conceptosAdicionales =
                        servicios_arr[0].conceptosAdicionales;

                    let serv = servicios_arr[0];
                    this.servicio_obj = serv;
                    this.actualizarCodigoDeBarrasOxxo();
                    console.log("servicio_obj", this.servicio_obj);
                    if (serv.costoCombinaciones) {
                        for (const keyUnidad in serv.costoCombinaciones) {
                            if (
                                serv.costoCombinaciones.hasOwnProperty(
                                    keyUnidad
                                )
                            ) {
                                const unidad =
                                    serv.costoCombinaciones[keyUnidad];

                                for (const indiceUnidad in unidad) {
                                    if (unidad.hasOwnProperty(indiceUnidad)) {
                                        const res = unidad[indiceUnidad];

                                        precio = Math.round(
                                            serv["precioCombinaciones"][
                                                keyUnidad
                                            ]
                                        );
                                        tipo_unidad = indiceUnidad;
                                        num_unidades =
                                            res.numeroDeUnidades +
                                            " Unidad(es) ";

                                        combinaciones.push({
                                            t: indiceUnidad,
                                            n: num_unidades,
                                            p:
                                                "Unidad " +
                                                indiceUnidad +
                                                ":$ " +
                                                precio
                                                    .toFixed(2)
                                                    .replace(
                                                        /\d(?=(\d{3})+\.)/g,
                                                        "$&,"
                                                    ),
                                        });
                                    }
                                }
                            }
                        }
                    } else {
                        for (const keyCombinacion in serv.precioCombinaciones) {
                            if (
                                serv.precioCombinaciones.hasOwnProperty(
                                    keyCombinacion
                                )
                            ) {
                                const combinacion =
                                    serv.precioCombinaciones[keyCombinacion];
                                var str_combinacion = "";
                                var str_costo_combinacion = 0;
                                str_costo_combinacion += combinacion.total;
                                for (const indiceUnidad in combinacion.combinacion) {
                                    if (
                                        combinacion.combinacion.hasOwnProperty(
                                            indiceUnidad
                                        )
                                    ) {
                                        const res =
                                            combinacion.combinacion[
                                                indiceUnidad
                                            ];

                                        //precio = Math.round(serv['precioCombinaciones'][keyUnidad])
                                        tipo_unidad = indiceUnidad;
                                        num_unidades = res + " Unidad(es) ";

                                        if (res > 0) {
                                            str_combinacion +=
                                                " " +
                                                indiceUnidad +
                                                " x " +
                                                num_unidades;
                                            //str_costo_combinacion += combinacion.total;
                                        }
                                    }
                                }
                                combinaciones.push({
                                    t: str_combinacion,
                                    p:
                                        "$ " +
                                        str_costo_combinacion
                                            .toFixed(2)
                                            .replace(
                                                /\d(?=(\d{3})+\.)/g,
                                                "$&,"
                                            ),
                                    precioConDescuento:
                                        combinacion.precioConDescuento,
                                    total: combinacion.total,
                                });
                            }
                        }
                    }

                    this.combinaciones_arr = combinaciones;
                    console.log("combinaciones_arr", this.combinaciones_arr);

                    if (serv.puntosIntermedios) {
                        for (const keyPunto in serv.puntosIntermedios) {
                            if (
                                serv.puntosIntermedios.hasOwnProperty(keyPunto)
                            ) {
                                const punto = serv.puntosIntermedios[keyPunto];
                                console.log("Punto", punto);
                                this.puntosIntermedios_array.push(punto);
                            }
                        }
                    }

                    this.clientesService
                        .obtenerPropiedadCliente(
                            this.cotizacion_obj.cliente,
                            "nombre"
                        )
                        .valueChanges()
                        .take(1)
                        .subscribe((nombre) => {
                            this.nombreCliente = nombre;
                        });
                    this.personalService
                        .obtenerPropiedadDeUsuario(
                            this.cotizacion_obj.usuarioQueCotizo,
                            "informacionPersonal"
                        )
                        .valueChanges()
                        .take(1)
                        .subscribe((info_personal) => {
                            console.log(info_personal);
                            this.nombreAgente =
                                info_personal["nombre"] +
                                " " +
                                info_personal["apellidoPaterno"] +
                                " " +
                                info_personal["apellidoMaterno"];
                        });
                    this.seccion = "mi_cotizacion";
                    /* if(this.cotizacion_obj.idNegocioHubSpot)
                    {
                        this.cotizacionesService.getNegocioHubSpot(this.cotizacion_obj.idNegocioHubSpot).take(1).subscribe(res2 => {
                            console.log("res2",res2)
                            if(res2["properties"].dealstage == "19311254")
                            {
                                this.cotizacionesService.updateCotizacionLeidaHubSpot(this.cotizacion_obj.idNegocioHubSpot ).take(1).subscribe(res3 => {
                                    console.log("res3",res3)
                                })
                            }
                            else{
                              this.cotizacionesService.updateCotizacionUltimaVezLeidaHubSpot(this.cotizacion_obj.idNegocioHubSpot ).take(1).subscribe(res3 => {
                                  console.log("res4",res3)
                              })
                            }
                        })
                    } */

                    this.showLoader = false;
                });
            });
        } else {
            this.afAuth.auth
                .signInWithEmailAndPassword("guest-user@trosten.com", "123456")
                .then(
                    (user) => {
                        this.activatedRoute.params.forEach((params: Params) => {
                            this.cotizacionId = params["id"];

                            this.cotizacionesService
                                .marcarCotizacionComoLeida(
                                    this.cotizacionId,
                                    ""
                                )
                                .then(() => {
                                    /*
                                                                      console.log(url);
                                                                      //window.open(url, '_self');
                                                                      var link = document.createElement('a');
                                                                      link.target = '_blank';
                                                                      link.href = url;
                                                                      document.body.appendChild(link); // Required for Firefox
                                                                      link.click();
                                                                      link.remove();*/
                                });

                            this.fechaActual = Date.now(); // Obtiene la fecha de hoy
                            this.cotizacion = this.cotizacionesService
                                .obtenerCotizacion(this.cotizacionId)
                                .valueChanges()
                                .take(1);
                            this.cotizacion.subscribe((cotizacion) => {
                                let servicios_arr = [];

                                //console.log("cotizacion",cotizacion)
                                this.cotizacion_obj = cotizacion;
                                for (var idServicio in cotizacion.servicios) {
                                    servicios_arr.push(
                                        cotizacion.servicios[idServicio]
                                    );
                                }

                                this.confirmacionesService
                                    .traerInfoDescuentos()
                                    .take(1)
                                    .subscribe((res) => {
                                        //console.log("descuentos",res)
                                        const descuentos = res as any[];
                                        descuentos.forEach((value) => {
                                            if (
                                                value.idc_codigos_descuento ==
                                                cotizacion.descuentoAGuardarMark
                                                    .idc_codigos_descuento
                                            ) {
                                                cotizacion.descuentoAGuardarMark =
                                                    value;
                                            }
                                        });
                                        console.log(
                                            "descuentoAGuardarMark",
                                            cotizacion.descuentoAGuardarMark
                                        );
                                        if (cotizacion.descuentoAGuardarMark) {
                                            if (
                                                cotizacion.descuentoAGuardarMark
                                                    .codigo
                                            ) {
                                                this.mensajeDescuento =
                                                    cotizacion.descuentoAGuardarMark.mensaje;
                                            }
                                        }
                                        if (cotizacion.descuentoAGuardarAdmin) {
                                            if (
                                                cotizacion
                                                    .descuentoAGuardarAdmin
                                                    .codigo
                                            ) {
                                                this.mensajeDescuento =
                                                    cotizacion.descuentoAGuardarAdmin.mensaje;
                                            }
                                        }
                                    });

                                let precio = 0;
                                let tipo_unidad = "";
                                let num_unidades = "";
                                let combinaciones = [];
                                let conceptosAdicionales = [];

                                conceptosAdicionales =
                                    servicios_arr[0].conceptosAdicionales;

                                let serv = servicios_arr[0];
                                this.servicio_obj = serv;
                                this.actualizarCodigoDeBarrasOxxo();
                                //console.log("servicio_obj",this.servicio_obj)
                                if (serv.costoCombinaciones) {
                                    for (const keyUnidad in serv.costoCombinaciones) {
                                        if (
                                            serv.costoCombinaciones.hasOwnProperty(
                                                keyUnidad
                                            )
                                        ) {
                                            const unidad =
                                                serv.costoCombinaciones[
                                                    keyUnidad
                                                ];

                                            for (const indiceUnidad in unidad) {
                                                if (
                                                    unidad.hasOwnProperty(
                                                        indiceUnidad
                                                    )
                                                ) {
                                                    const res =
                                                        unidad[indiceUnidad];

                                                    precio = Math.round(
                                                        serv[
                                                            "precioCombinaciones"
                                                        ][keyUnidad]
                                                    );
                                                    tipo_unidad = indiceUnidad;
                                                    num_unidades =
                                                        res.numeroDeUnidades +
                                                        " Unidad(es) ";

                                                    combinaciones.push({
                                                        t: indiceUnidad,
                                                        n: num_unidades,
                                                        p:
                                                            "Unidad " +
                                                            indiceUnidad +
                                                            ":$ " +
                                                            precio
                                                                .toFixed(2)
                                                                .replace(
                                                                    /\d(?=(\d{3})+\.)/g,
                                                                    "$&,"
                                                                ),
                                                    });
                                                }
                                            }
                                        }
                                    }
                                } else {
                                    for (const keyCombinacion in serv.precioCombinaciones) {
                                        if (
                                            serv.precioCombinaciones.hasOwnProperty(
                                                keyCombinacion
                                            )
                                        ) {
                                            const combinacion =
                                                serv.precioCombinaciones[
                                                    keyCombinacion
                                                ];
                                            var str_combinacion = "";
                                            var str_costo_combinacion = 0;
                                            str_costo_combinacion +=
                                                combinacion.total;
                                            for (const indiceUnidad in combinacion.combinacion) {
                                                if (
                                                    combinacion.combinacion.hasOwnProperty(
                                                        indiceUnidad
                                                    )
                                                ) {
                                                    const res =
                                                        combinacion.combinacion[
                                                            indiceUnidad
                                                        ];

                                                    tipo_unidad = indiceUnidad;
                                                    num_unidades =
                                                        res + " Unidad(es) ";

                                                    if (res > 0) {
                                                        str_combinacion +=
                                                            " " +
                                                            indiceUnidad +
                                                            " x " +
                                                            num_unidades;
                                                    }
                                                }
                                            }
                                            combinaciones.push({
                                                t: str_combinacion,
                                                p:
                                                    "$ " +
                                                    str_costo_combinacion
                                                        .toFixed(2)
                                                        .replace(
                                                            /\d(?=(\d{3})+\.)/g,
                                                            "$&,"
                                                        ),
                                                precioConDescuento:
                                                    combinacion.precioConDescuento,
                                                total: combinacion.total,
                                            });
                                        }
                                    }
                                }

                                this.combinaciones_arr = combinaciones;
                                //console.log("combinaciones_arr",this.combinaciones_arr)

                                if (serv.puntosIntermedios) {
                                    for (const keyPunto in serv.puntosIntermedios) {
                                        if (
                                            serv.puntosIntermedios.hasOwnProperty(
                                                keyPunto
                                            )
                                        ) {
                                            const punto =
                                                serv.puntosIntermedios[
                                                    keyPunto
                                                ];
                                            console.log("Punto", punto);
                                            this.puntosIntermedios_array.push(
                                                punto
                                            );
                                        }
                                    }
                                }

                                this.clientesService
                                    .obtenerPropiedadCliente(
                                        this.cotizacion_obj.cliente,
                                        "nombre"
                                    )
                                    .valueChanges()
                                    .take(1)
                                    .subscribe((nombre) => {
                                        this.nombreCliente = nombre;
                                    });
                                this.personalService
                                    .obtenerPropiedadDeUsuario(
                                        this.cotizacion_obj.usuarioQueCotizo,
                                        "informacionPersonal"
                                    )
                                    .valueChanges()
                                    .take(1)
                                    .subscribe((info_personal) => {
                                        console.log(info_personal);
                                        this.nombreAgente =
                                            info_personal["nombre"] +
                                            " " +
                                            info_personal["apellidoPaterno"] +
                                            " " +
                                            info_personal["apellidoMaterno"];
                                    });
                                this.seccion = "mi_cotizacion";

                                let multipathUpdateMarcarComoLeida = {};
                                multipathUpdateMarcarComoLeida[
                                    "cotizaciones/" +
                                        this.cotizacion_obj.$key +
                                        "/fueLeida/"
                                ] = true;
                                multipathUpdateMarcarComoLeida[
                                    "cotizacionesPorUsuario/" +
                                        this.cotizacion_obj.usuarioQueCotizo +
                                        "/" +
                                        this.cotizacion_obj.$key +
                                        "/fueLeida/"
                                ] = true;
                                multipathUpdateMarcarComoLeida[
                                    "cotizaciones/" +
                                        this.cotizacion_obj.$key +
                                        "/fueEnviada/"
                                ] = true;
                                multipathUpdateMarcarComoLeida[
                                    "cotizacionesPorUsuario/" +
                                        this.cotizacion_obj.usuarioQueCotizo +
                                        "/" +
                                        this.cotizacion_obj.$key +
                                        "/fueEnviada/"
                                ] = true;
                                this.afDB
                                    .object("/")
                                    .update(multipathUpdateMarcarComoLeida);

                                if (this.cotizacion_obj.idNegocioHubSpot) {
                                    this.cotizacionesService
                                        .getNegocioHubSpot(
                                            this.cotizacion_obj.idNegocioHubSpot
                                        )
                                        .take(1)
                                        .subscribe((res2) => {
                                            //console.log("res2",res2)
                                            if (
                                                res2["properties"].dealstage ==
                                                "19311254"
                                            ) {
                                                this.cotizacionesService
                                                    .updateCotizacionLeidaHubSpot(
                                                        this.cotizacion_obj
                                                            .idNegocioHubSpot
                                                    )
                                                    .take(1)
                                                    .subscribe((res3) => {
                                                        //console.log("res3",res3)
                                                    });
                                            } else {
                                                this.cotizacionesService
                                                    .updateCotizacionUltimaVezLeidaHubSpot(
                                                        this.cotizacion_obj
                                                            .idNegocioHubSpot
                                                    )
                                                    .take(1)
                                                    .subscribe((res3) => {
                                                        //console.log("res3",res3)
                                                    });
                                            }
                                        });
                                }

                                this.showLoader = false;

                                /*   let url = "https://trosten.azurewebsites.net/pdf-service/cotizacion-pdf-check-vista.php?id=" + cotizacion.idTrosten +
                                     "&o=" + serv.origen.alias +
                                     "&d=" + serv.destino.alias +
                                     "&i=" + serv.itinerario.inicioDeServicio +
                                     "&f=" + serv.itinerario.finDeServicio +
                                     "&c=" + JSON.stringify(combinaciones) +
                                     "&cA=" + JSON.stringify(conceptosAdicionales) +
                                     "&tv=" + cotizacion.tipoDeVenta +
                                     "&key=" + cotizacion.$key;

                                 this.urlPDF = url;

                                 this.cotizacionesService.marcarCotizacionComoLeida(this.cotizacionId, cotizacion.usuarioQueCotizo).then(function (message) {


                                     console.log(url);
                                     //window.open(url, '_self');
                                     var link = document.createElement('a');
                                     link.target = '_blank';
                                     link.href = url;
                                     document.body.appendChild(link); // Required for Firefox
                                     link.click();
                                     link.remove();
                                 });*/
                            });

                            // this.cotizacionCompleta = cotizacion;
                            /*
                          this.clientesService.obtenerPropiedadCliente(this.cotizacionCompleta.cliente ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                              this.nombreCliente = nombre
                           });

                          // Checa si el usuario tiene sesión iniciada
                          this.afAuth.authState.take(1).subscribe(auth => {
                            // El usuario no está logueado
                            if(!auth){
                              // Marca como leida la cotización
                              this.cotizacionesService.marcarCotizacionComoLeida(this.cotizacionId, cotizacion.usuarioQueCotizo);
                              // Inicializa el chat de Tawkto
                              //this.chatService.mostrarChat();
                            }
                          }); */
                            // Genera el código del Oxxo
                            /*            let referenciaOxxo = this.oxxoService.generarCodigoOxxo(cotizacion);
                                      this.codigoDeBarrasOxxo = this.oxxoService.crearCodigoDeBarras(referenciaOxxo);

                                      // Genera un arreglo de servicios y paradas
                                      for (var idServicio in cotizacion.servicios) {
                                          this.arregloServicios.push(cotizacion.servicios[idServicio])
                                          let puntosIntermedios = cotizacion.servicios[idServicio].puntosIntermedios
                                          let conceptosAdicionales =  cotizacion.servicios[idServicio].conceptosAdicionales
                                          for (var idPuntoIntermedio in puntosIntermedios) {
                                              this.arregloParadas.push(puntosIntermedios[idPuntoIntermedio]);
                                          }
                                          for (var idConcepto in conceptosAdicionales) {
                                              this.totalConceptos+= conceptosAdicionales[idConcepto].precio
                                          }
                                        }
                                  })*/
                        });
                        console.log("correct_login");
                    },
                    (error) => {
                        console.log("error_login");
                    }
                );
        }
    }

    cambiarSeccion(opcion) {
        this.seccion = opcion;
    }
    cambiarSeccion_Mi_Trosten(opcion) {
        this.mi_trosten_seccion = opcion;
    }
    cambiarSeccion_Camionetas(opcion) {
        this.camionetas_seccion = opcion;
    }

    printDiv(divName) {
        this.printing = true;
        window.print();
        return true;
        /*        var printContents = document.getElementById("printableArea").innerHTML;
        var popup = window.open('', '', 'height=400,width=800');
        printContents += '<link rel="stylesheet" href="https://cdn.jsdelivr.net/foundation/6.2.3/foundation.min.css">' +
            '<style>@media print{-webkit-print-color-adjust: exact !important;}</style>'
        popup.document.body.insertAdjacentHTML("beforeend", printContents);
        popup.focus(); //for IE
        popup.print()*/

        /*        var printWindow = window.open('', '', 'height=400,width=800');
        var divContents = document.getElementById("printableArea").innerHTML +
            "<script>" +
            "window.onload = function() {" +
            "     window.print();" +
            "};" +
            "<" + "/script>";
        printWindow.document.write(divContents);
        printWindow.document.close();*/
    }

    //Funcion que permite
    configurarMapa(indice, servicio) {
        // Almacena las variables del mapa y de los inputs de auto complete
        let mapas = document.getElementsByClassName("google-map");
        let opcionesMapa = {
            center: { lat: 19.273437, lng: -99.661012 }, // Ubicación de Trosten
            zoom: 10,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        this.map = new google.maps.Map(mapas[indice], opcionesMapa);
        this.directionsService = new google.maps.DirectionsService();
        this.directionsDisplay = new google.maps.DirectionsRenderer({
            draggable: true,
        });

        this.directionsDisplay.setMap(this.map);
        this.googleService.calcularRuta(
            this.directionsService,
            this.directionsDisplay,
            servicio
        );
    }

    irPdf() {
        this.activatedRoute.params.forEach((params: Params) => {
            this.cotizacionId = params["id"];
            this.fechaActual = Date.now(); // Obtiene la fecha de hoy
            this.cotizacion = this.cotizacionesService
                .obtenerCotizacion(this.cotizacionId)
                .valueChanges()
                .take(1);
            this.cotizacion.subscribe((cotizacion) => {
                let servicios_arr = [];

                console.log(cotizacion);
                for (var idServicio in cotizacion.servicios) {
                    servicios_arr.push(cotizacion.servicios[idServicio]);
                }

                let precio = 0;
                let tipo_unidad = "";
                let num_unidades = "";
                let combinaciones = [];
                let conceptosAdicionales = [];

                conceptosAdicionales = servicios_arr[0].conceptosAdicionales;

                let serv = servicios_arr[0];
                for (const keyUnidad in serv.costoCombinaciones) {
                    if (serv.costoCombinaciones.hasOwnProperty(keyUnidad)) {
                        const unidad = serv.costoCombinaciones[keyUnidad];
                        for (const indiceUnidad in unidad) {
                            if (unidad.hasOwnProperty(indiceUnidad)) {
                                const res = unidad[indiceUnidad];

                                precio = Math.round(
                                    serv["precioCombinaciones"][keyUnidad]
                                );
                                tipo_unidad = indiceUnidad;
                                num_unidades =
                                    res.numeroDeUnidades + " Unidad(es) ";

                                combinaciones.push({
                                    t: indiceUnidad,
                                    n: num_unidades,
                                    p:
                                        "Unidad " +
                                        indiceUnidad +
                                        ": $" +
                                        precio
                                            .toFixed(2)
                                            .replace(
                                                /\d(?=(\d{3})+\.)/g,
                                                "$&,"
                                            ),
                                });
                            }
                        }
                    }
                }

                this.cotizacionesService
                    .marcarCotizacionComoLeida(
                        this.cotizacionId,
                        cotizacion.usuarioQueCotizo
                    )
                    .then(function (message) {
                        let url =
                            "https://operacion.trosten.com/pdf-service/cotizacion-pdf-check-vista.php?id=" +
                            cotizacion.idTrosten +
                            "&o=" +
                            serv.origen.alias +
                            "&d=" +
                            serv.destino.alias +
                            "&i=" +
                            serv.itinerario.inicioDeServicio +
                            "&f=" +
                            serv.itinerario.finDeServicio +
                            "&c=" +
                            JSON.stringify(combinaciones) +
                            "&cA=" +
                            JSON.stringify(conceptosAdicionales) +
                            "&tv=" +
                            cotizacion.tipoDeVenta +
                            "&key=" +
                            cotizacion.$key;

                        console.log(url);
                        window.open(url, "_self");
                        /* var link = document.createElement('a');
                    link.target = '_blank';
                    link.href = url;
                    document.body.appendChild(link); // Required for Firefox
                    link.click();
                    link.remove();*/
                    });

                // this.cotizacionCompleta = cotizacion;
                /*
                this.clientesService.obtenerPropiedadCliente(this.cotizacionCompleta.cliente ,'nombre').valueChanges().take(1).subscribe(nombre=>{
                    this.nombreCliente = nombre
                 });

                // Checa si el usuario tiene sesión iniciada
                this.afAuth.authState.take(1).subscribe(auth => {
                  // El usuario no está logueado
                  if(!auth){
                    // Marca como leida la cotización
                    this.cotizacionesService.marcarCotizacionComoLeida(this.cotizacionId, cotizacion.usuarioQueCotizo);
                    // Inicializa el chat de Tawkto
                    //this.chatService.mostrarChat();
                  }
                }); */
                /*
              // Genera el código del Oxxo
              let referenciaOxxo = this.oxxoService.generarCodigoOxxo(cotizacion);
              this.codigoDeBarrasOxxo = this.oxxoService.crearCodigoDeBarras(referenciaOxxo);

              // Genera un arreglo de servicios y paradas
              for (var idServicio in cotizacion.servicios) {
                  this.arregloServicios.push(cotizacion.servicios[idServicio])
                  let puntosIntermedios = cotizacion.servicios[idServicio].puntosIntermedios
                  let conceptosAdicionales =  cotizacion.servicios[idServicio].conceptosAdicionales
                  for (var idPuntoIntermedio in puntosIntermedios) {
                      this.arregloParadas.push(puntosIntermedios[idPuntoIntermedio]);
                  }
                  for (var idConcepto in conceptosAdicionales) {
                      this.totalConceptos+= conceptosAdicionales[idConcepto].precio
                  }
                }*/
            });
        });
    }

    private actualizarCodigoDeBarrasOxxo(): void {
        let idTrosten = this.cotizacion_obj && this.cotizacion_obj.idTrosten ? this.cotizacion_obj.idTrosten : null;
        let inicioDeServicio = this.servicio_obj && this.servicio_obj.itinerario
            ? this.servicio_obj.itinerario.inicioDeServicio
            : null;

        if (!idTrosten || !inicioDeServicio) {
            this.codigoDeBarrasOxxo = null;
            this.codigoDeBarrasOxxoImagen = null;
            return;
        }

        let numeroDeViaje = this.obtenerNumeroDeViajeOxxo(idTrosten);
        let fechaVencimiento = this.obtenerFechaVencimientoOxxo(inicioDeServicio);

        if (!numeroDeViaje || !fechaVencimiento) {
            this.codigoDeBarrasOxxo = null;
            this.codigoDeBarrasOxxoImagen = null;
            return;
        }

        let codigoBase = '05' + numeroDeViaje + fechaVencimiento;
        let digitoVerificador = this.calcularDigitoVerificadorOxxo(codigoBase);

        if (digitoVerificador === null) {
            this.codigoDeBarrasOxxo = null;
            this.codigoDeBarrasOxxoImagen = null;
            return;
        }

        this.codigoDeBarrasOxxo = codigoBase + digitoVerificador;
        this.codigoDeBarrasOxxoImagen = this.generarImagenCodigoDeBarrasOxxo(this.codigoDeBarrasOxxo);
    }

    private obtenerNumeroDeViajeOxxo(idTrosten: any): string {
        if (!idTrosten) {
            return null;
        }

        let digitos = String(idTrosten).replace(/\D/g, '');

        if (!digitos) {
            return null;
        }

        digitos = digitos.slice(-5);

        while (digitos.length < 5) {
            digitos = '0' + digitos;
        }

        return digitos;
    }

    private obtenerFechaVencimientoOxxo(inicioDeServicio: any): string {
        let fechaInicio = this.obtenerFechaDesdeValor(inicioDeServicio);

        if (!fechaInicio) {
            return null;
        }

        let fechaVencimiento = new Date(fechaInicio.getTime() - (72 * 60 * 60 * 1000));

        return this.completarConCeros(fechaVencimiento.getDate(), 2)
            + this.completarConCeros(fechaVencimiento.getMonth() + 1, 2)
            + this.completarConCeros(fechaVencimiento.getFullYear() % 100, 2);
    }

    private obtenerFechaDesdeValor(valor: any): Date {
        if (!valor) {
            return null;
        }

        if (valor instanceof Date) {
            return isNaN(valor.getTime()) ? null : valor;
        }

        if (typeof valor === 'number') {
            let fechaNumero = new Date(valor);
            return isNaN(fechaNumero.getTime()) ? null : fechaNumero;
        }

        if (valor.seconds) {
            let fechaTimestamp = new Date(valor.seconds * 1000);
            return isNaN(fechaTimestamp.getTime()) ? null : fechaTimestamp;
        }

        let fecha = new Date(valor);
        return isNaN(fecha.getTime()) ? null : fecha;
    }

    private calcularDigitoVerificadorOxxo(codigoBase: string): number {
        if (!codigoBase || codigoBase.length !== 13 || !/^\d+$/.test(codigoBase)) {
            return null;
        }

        let suma = 0;

        for (let i = 0; i < codigoBase.length; i++) {
            suma += parseInt(codigoBase.charAt(i), 10) * (i + 1);
        }

        return suma % 10;
    }

    private generarImagenCodigoDeBarrasOxxo(codigo: string): string {
        if (!codigo) {
            return null;
        }

        try {
            let canvas = ioBarcode.CODE128C(codigo, {
                width: 2,
                height: 70,
                quite: 0,
                displayValue: false,
                backgroundColor: '#ffffff',
                lineColor: '#000000'
            });

            return canvas.toDataURL('image/png');
        } catch (error) {
            try {
                let canvas = ioBarcode.CODE128B(codigo, {
                    width: 2,
                    height: 70,
                    quite: 0,
                    displayValue: false,
                    backgroundColor: '#ffffff',
                    lineColor: '#000000'
                });

                return canvas.toDataURL('image/png');
            } catch (fallbackError) {
                return null;
            }
        }
    }

    private completarConCeros(valor: number, longitud: number): string {
        let valorTexto = String(valor);

        while (valorTexto.length < longitud) {
            valorTexto = '0' + valorTexto;
        }

        return valorTexto;
    }

    imprimirPantalla() {
        window.print();
    }

    verMenu(opcion) {
        this.opcion = opcion;
    }

    centrarTexto(txt, options, x, y, doc) {
        options = options || {};
        /* Use the options align property to specify desired text alignment
         * Param x will be ignored if desired text alignment is 'center'.
         * Usage of options can easily extend the function to apply different text
         * styles and sizes
         */
        if (options.align == "center") {
            // Get current font size
            var fontSize = doc.internal.getFontSize();
            var txtWidth =
                (doc.getStringUnitWidth(txt) * fontSize) /
                doc.internal.scaleFactor;

            // Get page width
            var pageWidth = doc.internal.pageSize.width;

            // Get the actual text's width
            /* You multiply the unit width of your string by your font size and divide
             * by the internal scale factor. The division is necessary
             * for the case where you use units other than 'pt' in the constructor
             * of jsPDF.
             */
            txtWidth =
                (doc.getStringUnitWidth(txt) * fontSize) /
                doc.internal.scaleFactor;

            // Calculate text's x coordinate
            x = (pageWidth - txtWidth) / 2;
        }

        // Draw text at x,y
        doc.text(txt, x, y);
    }

    crearPDF(servicio, noServicio, totalConceptos) {
        let doc = new jsPDF("p", "", "", true); //Nuevo objeto jspdf
        let numeroServicio = noServicio + 1;
        //Logo en Base64
        let logo = imgConfirmacion;
        doc.rect(0, 0, 210, 21, "F"); //Fondo negro
        doc.addImage(logo, "PNG", -10, -24, 230, 60, undefined, "FAST"); //imgb64,type, x, y , ancho, largo
        doc.setFontSize(12);
        doc.setTextColor(0, 128, 255);
        this.centrarTexto(
            "ID:" + this.cotizacionCompleta.idTrosten,
            { align: "center" },
            0,
            27,
            doc
        );
        this.centrarTexto(
            "¡Hola " + this.nombreCliente + "!",
            { align: "center" },
            0,
            34,
            doc
        );
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        this.centrarTexto(
            "AGRADECEMOS SU CONFIANZA Y PREFERENCIA EN NUESTRO SERVICIO,",
            { align: "center" },
            0,
            40,
            doc
        );
        this.centrarTexto(
            "A CONTINUACIÓN LE PRESENTAMOS LA COTIZACIÓN REQUERIDA PARA SU PRÓXIMO VIAJE",
            { align: "center" },
            0,
            45,
            doc
        );
        doc.addImage(monosVerdes, "PNG", 70, 40, 80, 25, undefined, "FAST"); //imgb64,type, x, y , ancho, largo
        doc.rect(0, 60, 210, 10, "F"); //pInicial, altura, p.final ancho
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(9);
        this.centrarTexto(
            "Servicio " + numeroServicio.toString(),
            { align: "center" },
            0,
            65,
            doc
        );
        doc.setFontSize(12);
        doc.setTextColor(0, 128, 255);
        this.centrarTexto(
            "Viaje " +
                this.cotizacionCompleta.tipoDeVenta +
                ": " +
                this.cotizacionCompleta.aliasOrigen +
                " - " +
                this.cotizacionCompleta.aliasDestino,
            { align: "center" },
            0,
            80,
            doc
        );
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setTextColor(0, 128, 255);
        doc.text(10, 90, "Origen: ");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        let origen = doc.splitTextToSize(
            this.cotizacionCompleta.aliasOrigen,
            50
        );
        doc.text(10, 95, origen);
        doc.setFontSize(10);
        doc.setTextColor(0, 128, 255);
        doc.text(80, 90, "Destino: ");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        let destino = doc.splitTextToSize(
            this.cotizacionCompleta.aliasDestino,
            50
        );
        doc.text(80, 95, destino);
        doc.setFontSize(10);
        doc.setTextColor(0, 128, 255);
        doc.text(150, 90, "Total de pasajeros: ");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        let totalPasajeros = doc.splitTextToSize(
            servicio.parametros.cantidadDePasajeros.toString(),
            50
        );
        doc.text(165, 95, totalPasajeros);
        doc.setFontSize(10);
        doc.setTextColor(0, 128, 255);
        doc.text(10, 105, " Inicio de servicio: ");
        doc.text(80, 105, " Fin de servicio: ");
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(8);
        if (new Date(servicio.itinerario.inicioDeServicio).getHours() < 12)
            doc.text(
                10,
                110,
                new Date(servicio.itinerario.inicioDeServicio)
                    .toLocaleString()
                    .toString() + " am"
            );
        else
            doc.text(
                10,
                110,
                new Date(servicio.itinerario.inicioDeServicio)
                    .toLocaleString()
                    .toString() + " pm"
            );
        if (new Date(servicio.itinerario.finDeServicio).getHours() < 12)
            doc.text(
                80,
                110,
                new Date(servicio.itinerario.finDeServicio)
                    .toLocaleString()
                    .toString() + " am"
            );
        else
            doc.text(
                80,
                110,
                new Date(servicio.itinerario.finDeServicio)
                    .toLocaleString()
                    .toString() + " pm"
            );
        if (
            servicio.indicacionesEspeciales != undefined &&
            servicio.indicacionesEspeciales != ""
        ) {
            doc.setFontSize(10);
            doc.setTextColor(0, 128, 255);
            doc.text(10, 120, "Indicaciones especiales: ");
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(8);
            let indicaciones = doc.splitTextToSize(
                servicio.indicacionesEspeciales,
                100
            );
            doc.text(10, 125, indicaciones);
        } else {
            doc.setFontSize(12);
            doc.text(10, 120, "Indicaciones especiales: ");
            doc.setFontSize(10);
            let indicaciones = doc.splitTextToSize(
                "Este servicio no cuenta con indicaciones especiales",
                100
            );
            doc.text(10, 125, indicaciones);
        }

        let anchoTipo = 10;
        for (const keyUnidad in servicio.costoCombinaciones) {
            if (servicio.costoCombinaciones.hasOwnProperty(keyUnidad)) {
                const unidad = servicio.costoCombinaciones[keyUnidad];
                for (const indiceUnidad in unidad) {
                    if (unidad.hasOwnProperty(indiceUnidad)) {
                        const res = unidad[indiceUnidad];
                        let precio = Math.round(
                            servicio["precioCombinaciones"][keyUnidad]
                        );
                        switch (indiceUnidad) {
                            case "Tipo 1":
                                doc.setTextColor(0, 0, 0);
                                doc.text(
                                    anchoTipo,
                                    145,
                                    indiceUnidad +
                                        ": " +
                                        res.numeroDeUnidades +
                                        " Toyota hiace o similar"
                                );
                                doc.text(anchoTipo, 150, "(10 a 14 pasajeros)");
                                doc.setTextColor(0, 128, 255);
                                doc.text(
                                    anchoTipo + 5,
                                    155,
                                    "Total: $" + precio.toString()
                                );
                                break;
                            case "Tipo 2":
                                doc.setTextColor(0, 0, 0);
                                doc.text(
                                    anchoTipo,
                                    145,
                                    indiceUnidad +
                                        ": " +
                                        res.numeroDeUnidades +
                                        " Sprinter"
                                );
                                doc.text(anchoTipo, 150, "(20 pasajeros)");
                                doc.setTextColor(0, 128, 255);
                                doc.text(
                                    anchoTipo + 5,
                                    155,
                                    "Total: $" + precio.toString()
                                );
                                break;
                            case "Auto":
                                doc.setTextColor(0, 0, 0);
                                doc.text(
                                    anchoTipo,
                                    145,
                                    indiceUnidad +
                                        ": " +
                                        res.numeroDeUnidades +
                                        " básicos y ejecutivos tipo sedán"
                                );
                                doc.text(anchoTipo, 150, "(3 a 4 pasajeros)");
                                doc.setTextColor(0, 128, 255);
                                doc.text(
                                    anchoTipo + 5,
                                    155,
                                    "Total: $" + precio.toString()
                                );
                                break;
                            case "Lujo":
                                doc.setTextColor(0, 0, 0);
                                doc.text(
                                    anchoTipo,
                                    145,
                                    indiceUnidad +
                                        ": " +
                                        res.numeroDeUnidades +
                                        " Sprinter de Lujo"
                                );
                                doc.text(anchoTipo, 150, "(16 a 17 pasajeros)");
                                doc.setTextColor(0, 128, 255);
                                doc.text(
                                    anchoTipo + 5,
                                    155,
                                    "Total: $" + precio.toString()
                                );
                                break;
                            default:
                                break;
                        }
                        anchoTipo = anchoTipo + 55;
                    }
                }
            }
        }
        doc.setFontSize(12);
        doc.setTextColor(203, 213, 1);
        doc.text(10, 165, "Paradas del viaje");
        doc.text(130, 165, "Conceptos Adicionales");
        this.centrarTexto(
            "Precio por unidades contratadas",
            { align: "center" },
            0,
            137,
            doc
        );

        let index = 1;
        let espacio = 173;
        this.arregloParadas.forEach((parada) => {
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(8);
            let anchoTexto = doc.splitTextToSize(
                index + ". " + parada.direccion,
                80
            );
            doc.text(10, espacio, anchoTexto);
            index++;
            espacio = espacio + 5;
        });
        let indexConceptos = 1;
        let espacioConceptos = 173;
        for (const key in servicio.conceptosAdicionales) {
            if (servicio.conceptosAdicionales.hasOwnProperty(key)) {
                const element = servicio.conceptosAdicionales[key];
                doc.text(
                    130,
                    espacioConceptos,
                    +indexConceptos +
                        ". " +
                        element.descripcion +
                        ": $" +
                        element.precio
                );
                espacioConceptos = espacioConceptos + 8;
            }
        }
        doc.addImage(oxxoImg, "PNG", -10, 205, 230, 112, undefined, "FAST"); //imgb64,type, x, y , ancho, largo

        doc.save("doc.pdf"); //Se crea el pdf final
    }

    copyToClipboard() {
        /* const el = document.createElement('textarea');
         el.value = "https://operacion.trosten.com/#/confirmacion/"+this.confirmacionId;
         document.body.appendChild(el);
         el.select();
         document.execCommand('copy');
         document.body.removeChild(el);
 */
        var inputc = document.body.appendChild(document.createElement("input"));
        inputc.value = window.location.href;
        inputc.focus();
        inputc.select();
        document.execCommand("copy");
        inputc.parentNode.removeChild(inputc);
        alert("Se ha copiado correctamente el link a este documento!");
    }

    cargarConsideracionesAdicionales() {
        this.cotizacionesService.getConsideracionesAdicionales().subscribe((data: any) => {
            let items = data || [];
            this.consideracionesData = {
                horas_extras: items.filter(i => i.seccion === 'horas_extras'),
                cancelaciones: items.filter(i => i.seccion === 'cancelaciones'),
                reprogramaciones: items.filter(i => i.seccion === 'reprogramaciones')
            };
        });
    }

    getEscenarios(seccion: string): string[] {
        let items = this.consideracionesData[seccion] || [];
        let escenarios = [];
        items.forEach(i => {
            if (escenarios.indexOf(i.escenario) === -1) escenarios.push(i.escenario);
        });
        return escenarios;
    }

    getTiposVehiculo(seccion: string): string[] {
        let items = this.consideracionesData[seccion] || [];
        let tipos = [];
        items.forEach(i => {
            if (tipos.indexOf(i.tipo_vehiculo) === -1) tipos.push(i.tipo_vehiculo);
        });
        return tipos;
    }

    getValor(seccion: string, escenario: string, tipoVehiculo: string): string {
        let items = this.consideracionesData[seccion] || [];
        let item = items.find(i => i.escenario === escenario && i.tipo_vehiculo === tipoVehiculo);
        if (!item) return '';
        return item.valor == 0 ? 'Sin penalización' : '$' + parseFloat(item.valor).toFixed(2);
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/components/cotizacion/cotizacion.component.ts